import { Link } from 'react-router-dom'
import { APP_VERSION } from '../../../version'
import Logo from './Logo'
import { CADABLE_URL, INVITE_HREF } from './ui'

const heading = 'font-mono text-[10px] uppercase tracking-widest text-slate-500'
const link = 'bp-focus font-display text-sm text-slate-400 transition-colors duration-150 hover:text-cyan-300'
const cell = 'border-white/[0.07] px-5 py-3 md:px-8'
const key = 'font-mono text-[10px] uppercase tracking-widest text-slate-600'
const value = 'mt-0.5 font-mono text-xs tabular-nums text-slate-300'

/** Landing footer: brand and link columns, closed by a drawing title-block row. */
export default function SiteFooter() {
  const year = new Date().getFullYear()
  return (
    <footer className="relative border-t border-white/[0.07]">
      <div className="grid gap-10 px-5 py-14 md:grid-cols-[1.6fr_1fr_1fr_1fr] md:px-12">
        <div>
          <Logo glow={false} />
          <p className="mt-4 max-w-xs font-display text-sm leading-relaxed text-slate-500">AI that turns engineering drawings into verified CNC G-code.</p>
          <p className="mt-6 flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-cyan-400">
            <span className="h-1.5 w-1.5 rounded-full bg-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.8)]" />Invite-only preview
          </p>
        </div>
        <nav aria-label="Products">
          <h3 className={heading}>Products</h3>
          <ul className="mt-4 space-y-2.5">
            <li><Link to="/login" className={link}>GCodr</Link></li>
            <li>{CADABLE_URL
              ? <a href={CADABLE_URL} target="_blank" rel="noopener noreferrer" className={link}>CADable</a>
              : <span className="font-display text-sm text-slate-600">CADable · Soon</span>}</li>
            <li><Link to="/features" className={link}>Features</Link></li>
            <li><Link to="/pricing" className={link}>Pricing</Link></li>
          </ul>
        </nav>
        <nav aria-label="Resources">
          <h3 className={heading}>Resources</h3>
          <ul className="mt-4 space-y-2.5">
            <li><Link to="/docs" className={link}>Docs</Link></li>
            <li><a href={INVITE_HREF} className={link}>Request an invite</a></li>
            <li><a href="mailto:contact@gcodr.dev" className={link}>contact@gcodr.dev</a></li>
          </ul>
        </nav>
        <nav aria-label="Legal">
          <h3 className={heading}>Legal</h3>
          <ul className="mt-4 space-y-2.5">
            <li><Link to="/terms" className={link}>Terms of Service</Link></li>
            <li><Link to="/privacy" className={link}>Privacy Policy</Link></li>
          </ul>
        </nav>
      </div>
      <div className="grid grid-cols-2 border-t border-white/[0.07] md:grid-cols-[1fr_1fr_1fr_1fr_2fr]">
        <div className={cell}><div className={key}>Title</div><div className={value}>GCODR</div></div>
        <div className={`${cell} border-l`}><div className={key}>Rev</div><div className={value}>{APP_VERSION}</div></div>
        <div className={`${cell} border-t md:border-l md:border-t-0`}><div className={key}>Scale</div><div className={value}>1:1</div></div>
        <div className={`${cell} border-l border-t md:border-t-0`}><div className={key}>Dwg no.</div><div className={value}>001</div></div>
        <div className={`${cell} col-span-2 border-t md:col-span-1 md:border-l md:border-t-0`}><div className={key}>Date {year}</div><div className={value}>&copy; {year} GCodr. All rights reserved.</div></div>
      </div>
    </footer>
  )
}
